import { createSelector } from 'reselect';
import { createMatchSelector } from 'connected-react-router';
import ChildrenEntity from 'signin-app/entities/children';
import { isPrefetching } from 'signin-app/components/private-route/selectors';
import { groups } from 'signin-app/groups/selectors';
import { isPinApp } from 'signin-app/login/selectors';
import { pinLoginResponse } from 'signin-app/pin/selectors';
import { childPickupBehaviorIds as ChildPickupBehaviorIds } from '@famly/vet_child-pickup-behavior-ids';
import RoutesMap from 'signin-app/routes/routes-map';
import { pinEmployees } from 'signin-app/employee/selectors';
import { childRequiresPickupInfo } from './child-requires-pickup-info';
const getChildIdFromProps = (_, props) => {
    const { childId, child, match } = props;
    if (childId) {
        return childId;
    }
    else if (child) {
        return child.id;
    }
    else if (match) {
        return match.params.childId;
    }
    return '';
};
// PIN Child selectors
const childOverview = createSelector(pinLoginResponse, getChildIdFromProps, (pinPeople, childId) => {
    const childCheckin = pinPeople
        ? pinPeople.children.find(childCheckin => childCheckin.child.id === childId)
        : undefined;
    return childCheckin;
});
const childBehaviors = createSelector(childOverview, overview => overview && overview.behaviors);
export const canSelectOtherChildsParent = createSelector(childBehaviors, behaviors => Boolean(behaviors && behaviors.find(behavior => behavior.id === ChildPickupBehaviorIds.ShowOtherParentsPickupOption)));
export const requiresPickupInfo = createSelector(childBehaviors, behaviors => Boolean(behaviors && behaviors.find(behavior => behavior.id === ChildPickupBehaviorIds.RequiresPickupInfo)));
export const pinChildren = createSelector(pinLoginResponse, pinPeople => pinPeople && pinPeople.children && pinPeople.children.map(childCheckin => childCheckin.child));
export const getPinChild = createSelector(childOverview, overview => {
    return overview && overview.child;
});
export const isChildCheckedIn = createSelector(childOverview, overview => {
    return Boolean(overview && overview.child.checkedIn);
});
export const childPinRelations = createSelector(childOverview, overview => {
    return overview && overview.relations;
});
export const getPinChildren = createSelector(pinLoginResponse, pinPeople => {
    return pinPeople && pinPeople.children.map(childOverview => childOverview.child);
});
export const getChildIndex = createSelector(getPinChildren, getChildIdFromProps, (pinChildren, childId) => {
    if (pinChildren) {
        return pinChildren.findIndex(child => child.id === childId);
    }
    return undefined;
});
const getNextPerson = createSelector(getPinChildren, getChildIndex, pinEmployees, (pinChildren, childIndex, pinEmployees) => {
    const employeesArray = pinEmployees === null || pinEmployees === void 0 ? void 0 : pinEmployees.toArray();
    const employee = employeesArray ? employeesArray[0] : null;
    if (childIndex && childIndex < 0) {
        return undefined;
    }
    if (pinChildren && childIndex !== undefined && !pinChildren.get(childIndex + 1) && employee) {
        return employee;
    }
    if (pinChildren && childIndex !== undefined) {
        return pinChildren.get(childIndex + 1);
    }
    return undefined;
});
const hasProperty = (obj, property) => {
    return property in obj;
};
export const nextPersonUrl = createSelector(getNextPerson, nextPerson => {
    const isEmployee = nextPerson ? hasProperty(nextPerson, 'employeeId') : false;
    if (nextPerson && isEmployee) {
        return `/employee/${nextPerson.id}/${nextPerson.checkedIn ? 'checkout' : 'checkin'}`;
    }
    if (nextPerson) {
        return `/child/${nextPerson.id}/${nextPerson.checkedIn ? 'checkout' : 'checkin'}`;
    }
    return RoutesMap.pin;
});
export const isFetchingChild = (state) => state.child.isFetching;
export const childRelations = (state) => state.child.relations;
// ENTITIY child + common
export const relations = createSelector(childRelations, childPinRelations, (relations, pinRelations) => {
    return pinRelations ? pinRelations : relations;
});
export const childName = createSelector(isPinApp, ChildrenEntity.selectors.getById, getPinChild, (pinApp, entityChild, pinChild) => {
    const child = pinApp ? pinChild : entityChild;
    return child ? child.name.firstName : '';
});
export const isFetching = createSelector(isFetchingChild, isPrefetching, (fetchingChild, prefetching) => fetchingChild || prefetching);
export const makeChildSelector = (routePath) => {
    const matchSelector = createMatchSelector(routePath);
    return createSelector(ChildrenEntity.selectors.entityMap, matchSelector, (childrenEntityMap, match) => {
        if (!match) {
            return null;
        }
        const { childId } = match.params;
        const child = childrenEntityMap.find(child => child.id === childId);
        return child;
    });
};
export const childsGroupId = createSelector(ChildrenEntity.selectors.entityMap, getChildIdFromProps, (childrenEntityMap, childId) => {
    const child = childrenEntityMap.find(child => child.id === childId);
    return child ? child.groupId : '';
});
export const requirePickupInfo = createSelector(childsGroupId, groups, childBehaviors, (groupId, allGroups, behaviors) => childRequiresPickupInfo(behaviors ? behaviors.toArray().map(behavior => behavior.id) : [], allGroups.find(group => group.groupId === groupId)));
export const currentChildGroupId = createSelector(ChildrenEntity.selectors.getById, child => {
    if (child) {
        return child.lastCheckIn ? child.lastCheckIn.groupId : child.groupId;
    }
    return '';
});
